import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_COUNTRY} from '../../../utils/DropdownOptionPropsUtils';

export const countryResource: DropdownOptionProps[] = [
    {
        name: SELECT_COUNTRY, value: SELECT_COUNTRY
    },
    {
        name: 'Germany', value: 'DE'
    },
    {
        name: 'Poland', value: 'PL'
    },
    {
        name: 'USA', value: 'US'
    },
    {
        name: 'India', value: 'IND'
    },
    {
        name: 'Austria', value: 'AT'
    },
    {
        name: 'Denmark', value: 'DK'
    },
    {
        name: 'World', value: 'WW'
    },
    {
        name: 'Cross_Country', value: 'XC'
    },
    {
        name: 'Bulgaria', value: 'BG'
    },
    {
        name: 'Czechia', value: 'CZ'
    },
    {
        name: 'Greece', value: 'GR'
    },
    {
        name: 'Estonia', value: 'EE'
    },
    {
        name: 'Finland', value: 'FI'
    },
    {
        name: 'Hungary', value: 'HU'
    },
    {
        name: 'Lithuania', value: 'LT'
    },
    {
        name: 'Latvia', value: 'LV'
    },
    {
        name: 'Norway', value: 'NO'
    },
    {
        name: 'Romania', value: 'RO'
    },
    {
        name: 'Serbia', value: 'RS'
    },
    {
        name: 'Sweden', value: 'SE'
    },
    {
        name: 'Turkiye', value: 'TR'
    }
];
